// src/components/Footer.js
import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white p-4 text-center">
      <p>&copy; 2024 Marvin Walls. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
